import styles from "./SplitSearchForm.module.scss";
import SearchTabs, { IMEI_TAB, MODEL_TAB } from "./SearchTabs";
import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import SearchAutoSuggest from "../SearchAutoSuggest/SearchAutoSuggest";
import { useState } from "react";
import { Device, TradeInApiError } from "../types";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";

const IMEITooltip = () => (
  <Tooltip
    icon
    anchor="center"
    verticalAnchor="bottom"
    popoverClassname={styles.splitForm__tooltipPopover}
  >
    <p>Dial *#06# on your phone to get to the IMEI1 number</p>
  </Tooltip>
);

type SplitSearchFormParams = {
  onInputChange: (e: { target: { value: string } }) => void;
  searchString: string;
  searchResult: Device[];
  totalResults: number;
  onSelectDevice: (deviceId: string) => void;
  errorMessage: TradeInApiError | null;
  onTabChange: (tabIndex: number) => void;
};

const SplitSearchForm = ({
  onInputChange,
  searchString,
  searchResult,
  onSelectDevice,
  errorMessage,
  onTabChange,
}: SplitSearchFormParams) => {
  const [activeTab, setActiveTab] = useState(MODEL_TAB);

  const placeholder =
    activeTab === MODEL_TAB ? "e.g. iPhone 13 128gb" : "e.g. 346599763528495";

  const formTitle =
    activeTab === MODEL_TAB ? (
      <>Enter the device name or model</>
    ) : (
      <>
        Enter the device IMEI <IMEITooltip />
      </>
    );

  return (
    <div className={styles.splitForm}>
      <SearchTabs
        activeTab={activeTab}
        onClickTab={(tabIndex) => {
          setActiveTab(tabIndex);
          onTabChange(tabIndex);
        }}
      />

      <div className={styles.splitForm__form}>
        <label
          htmlFor="searchDevice"
          data-cy="search-device-input-label"
          className={styles.splitForm__title}
        >
          {formTitle}
        </label>
        <SearchAutoSuggest
          onInputChange={onInputChange}
          placeholder={placeholder}
          searchString={searchString}
          searchResult={searchResult}
          onSelectDevice={onSelectDevice}
        />
        {activeTab === IMEI_TAB && (
          <div className={styles.splitForm__charCount}>
            {searchString ? searchString.replace(/\s/g, "").length : "0"}/15
          </div>
        )}
      </div>
      {errorMessage && (
        <Message
          title={errorMessage.title}
          body={errorMessage.body}
          type={"error"}
          className={styles.searchForm__searchError}
        />
      )}
    </div>
  );
};

export default SplitSearchForm;
